<template>
  <div>
    <Modal class="editBlock servelistModal" v-model="modal" title="阶级异动" width="35" footer-hide>
      <div class="bodyhigh">
        <div class="bodytwice">
          <div class="content">
            <Row>
              <Col span="3">
                <label class="label">帐号</label>
              </Col>
              <Col span="9">
                <Input
                  class="editInput account"
                  v-model="account=maobj.account"
                  type="text"
                  disabled
                ></Input>
              </Col>
              <Col span="3">
                <label class="label">ID</label>
              </Col>
              <Col span="9">
                <Input class="editInput" v-model="account=maobj.maid" type="text" disabled></Input>
              </Col>
            </Row>
            <Row>
              <Col span="3">
                <label class="label">现在阶级</label>
              </Col>
              <Col span="9">
                <Input class="editInput" :value="lvname(maobj.lv)" type="text" disabled></Input>
              </Col>
              <Col span="3">
                <label class="label" style="margin-left:'-20px'">异动后阶级</label>
              </Col>
              <Col span="9">
                <Select class="editInput" v-model="lv">
                  <!-- <Option value="1">客服</Option> -->
                  <Option value="2">客服管理员</Option>
                </Select>
              </Col>
            </Row>
            <div class="bodytwice-bottom">
              <Row>
                <Col span="3">
                  <label class="label">动作</label>
                </Col>
                <Col span="9">
                  <Select class="editInput" v-model="action">
                    <Option value="1">晋升</Option>
                    <!-- <Option value="0">降级</Option> -->
                  </Select>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" @click="upConfirm">提交</div>
          <div class="btn" @click="modal=false">取消</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "servelistModal",
  props:{
    maUpStatus: {
      type: Boolean,
      default: false
    },
    maobj: Object
  },
  data () {
    return {
      lv: '',
      action: ''
    }
  },
  computed: {
    ...mapGetters(['username']),
    modal: {
      get () {
        return this.maUpStatus
      },
      set (val) {
        this.$emit("update:maUpStatus", val)

      }
    }
  },
  methods: {
    //提交确定
    upConfirm () {
      if (this.password != this.passwordAgain) {
        this.different = true
        return
      }
      let obj = {
        maid: Number(this.maobj.maid),
        updmaid: Number(this.username.maid),
        updmalv: Number(this.lv),
        type: this.action
      }
      this.$axios.updmalv(obj)
        .then(res => {
          this.$emit("getServeData")
          this.lv = ''
          this.action = ''
          if(res.status == 0) {
            this.$Message.error(res.msg)
          }
        })
        .catch(err => console.error(err))
      this.modal = false
    },
    lvname (val) {
      return val == 1 ? "客服" : "客服管理员"
    }
  }
}
</script>
<style lang="less">
.servelistModal {
  .editInput {
    &.cellphone {
      width: 76%;
      margin-left: 15px;
    }
    &.account {
      margin-left: 10px;
    }
    &.email {
      width: 90%;
    }
  }
  .passwordAgain {
    p {
      color: var(--main-red);
      margin-top: -10px;
      margin-left: 70px;
    }
  }
  .label {
    display: inline-block;
    width: 100%;
    text-align: right;
    transform: translateY(10px);
    white-space: nowrap;
  }
}
</style>